import React, { useEffect, useState } from "react";
import TodayTrend from "../api/TodayTrend";
import MovieCard from "./MovieCard";
import { Link } from "react-router-dom";
import { Grid, Typography, CircularProgress, Box, Button } from "@mui/material";
import "../App.css";

const TrendAll = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const controller = new AbortController();
    setLoading(true);
    setError(null);
    TodayTrend({ signal: controller.signal })
      .then((response) => {
        setData(response.data.results || []);
      })
      .catch((err) => {
        if (err?.name === 'CanceledError' || err?.name === 'AbortError') return;
        setError("Could not load trending movies. Please try again.");
      })
      .finally(() => {
        if (!controller.signal.aborted) setLoading(false);
      });
    return () => controller.abort();
  }, []);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ p: 4, textAlign: 'center' }}>
        <Typography sx={{ color: '#fff', mb: 2 }} role="alert">{error}</Typography>
        <Button variant="outlined" onClick={() => window.location.reload()}>Retry</Button>
      </Box>
    );
  }

  return (
    <div>
      <Typography
        variant="h1"
        component="h1"
        sx={{ color: '#B3B3B3', fontSize: { xs: '1.5rem', md: '2rem' }, marginBottom: 2, textAlign: 'center' }}
      >
        Today's Trending Movies
      </Typography>
      <Grid container spacing={2}>
        {data.map((movie) => (
          <Grid className="Link" item xs={6} sm={4} md={3} lg={2} key={movie.id}>
            <Link
              to={`/movie/${movie.id}`}
              aria-label={`View details for ${movie.title || movie.original_name}`}
            >
              <div className="cardMovie">
                <MovieCard data={movie} />
              </div>
            </Link>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default TrendAll;
